import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer-frame",
  style: {"position":"absolute","bottom":"1px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#5d7186","font-size":"14px"} }, "Copyright 2022. Jin solutions Co., Ltd. All rights reserved.   ", -1)

import AppImage from './AppImage.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(AppImage, {
      name: "logo",
      style: {"width":"100px","height":"10px"}
    })
  ]))
}
}

})